import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitopunedailycab() {



const cardData = {
  keyword: " Navi Mumbai to Pune Daily Cab Service",

  "headingDescription": "Omshree Cab provides reliable and comfortable Swift Dzire on rent in Navi Mumbai for travelers who want a smooth, efficient, and budget‑friendly ride for city travel, airport transfers, family outings, or outstation trips. The Swift Dzire is a popular sedan known for its excellent fuel efficiency, comfortable seating, compact design, and easy handling — making it ideal for solo travelers, couples, and small families. We offer flexible rental options including one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. All Swift Dzire vehicles in our fleet are air‑conditioned, well‑maintained, and driven by professional chauffeurs familiar with Navi Mumbai’s roads and traffic. With easy online booking, punctual pickups from anywhere in Navi Mumbai (including airport, railway stations, hotels, and residences), and 24/7 customer support, renting a Swift Dzire in Navi Mumbai becomes a smooth and stress‑free experience.",
  "topPlaces": [
    {
      "title": "Central Park Kharghar",
      "description": "Central Park in Kharghar is one of Navi Mumbai’s largest and most scenic urban parks, featuring sprawling green lawns, landscaped gardens, walking paths, and recreational areas perfect for family picnics, morning walks, and relaxation. Visitors enjoy the peaceful environment, open spaces, and scenic surroundings. Renting a Swift Dzire makes it convenient and comfortable for visitors to reach this outdoor destination and enjoy quality time with friends and family."
    },
    {
      "title": "Pandavkada Waterfalls",
      "description": "Pandavkada Waterfalls is a beautiful natural attraction near Kharghar, especially popular during the monsoon season when water cascades over rocky cliffs amid lush greenery. Visitors often come here for nature walks, photography, and short treks. Renting a Swift Dzire in Navi Mumbai provides an easy and comfortable way for travelers to reach this scenic spot and enjoy the refreshing environment."
    },
    {
      "title": "Seawoods Grand Central Mall",
      "description": "Seawoods Grand Central Mall is a major shopping and entertainment destination featuring international brands, eateries, cafés, and a multiplex cinema. Visitors can shop, dine, and enjoy leisure activities with family and friends. Renting a Swift Dzire makes it easy to travel comfortably to this popular mall while exploring the vibrant lifestyle and shopping scene of Navi Mumbai."
    },
    {
      "title": "Utsav Chowk",
      "description": "Utsav Chowk is a well‑known landmark in Kharghar recognized for its unique architectural design and decorative fountains. The area around the chowk has several restaurants, cafés, and shops where visitors can spend leisure time. It’s a popular spot for evening outings and photography. Renting a Swift Dzire offers an efficient and comfortable ride to this vibrant city spot."
    },
    {
      "title": "Palm Beach Road",
      "description": "Palm Beach Road is one of Navi Mumbai’s most scenic roads, connecting Vashi, Nerul, and Belapur and offering views of the waterfront and skyline. Many people enjoy evening drives along this route because of the calm environment and picturesque setting. Renting a Swift Dzire provides a smooth and comfortable city drive while sightseeing along this iconic road."
    },
    {
      "title": "Belapur Fort",
      "description": "Belapur Fort is a historic site near CBD Belapur that reflects a rich cultural past. Visitors can explore old fort walls, scenic surroundings, and learn about the area’s heritage. Renting a Swift Dzire makes it easy for visitors to reach this historical attraction and enjoy the peaceful environment."
    },
    {
      "title": "ISKCON Kharghar",
      "description": "ISKCON Kharghar is a spiritual center dedicated to Lord Krishna and offers a peaceful atmosphere for devotees and visitors. The temple hosts prayers, meditation sessions, and cultural programs. Renting a Swift Dzire provides convenient and comfortable transportation for devotees planning a visit to this spiritual destination."
    },
    {
      "title": "Golf Course Kharghar",
      "description": "The Kharghar Golf Course is a popular outdoor recreational area featuring green fields and scenic views. Visitors enjoy walking, relaxation, and leisure activities in this well‑maintained environment. Renting a Swift Dzire provides adequate space and comfort to reach this pleasant location while exploring Navi Mumbai."
    },
    {
      "title": "Nerul Balaji Temple",
      "description": "Nerul Balaji Temple is a religious site dedicated to Lord Venkateswara and is known for its traditional South Indian architectural style and peaceful setting. Devotees and tourists visit for darshan, prayers, and spiritual experiences. Renting a Swift Dzire offers a comfortable option to reach this revered temple within Navi Mumbai."
    },
    {
      "title": "Sagar Vihar",
      "description": "Sagar Vihar is a peaceful waterfront promenade in Vashi overlooking the Thane Creek, popular for evening walks, photography, and family outings. Visitors enjoy the cool breeze and scenic views, especially during sunset. Renting a Swift Dzire provides a smooth and comfortable ride to this scenic waterfront destination."
    }
  ],



services: [
{
name: "Navi Mumbai to Pune Cab",
description: "Navi Mumbai to Pune cab service provides comfortable intercity transportation between Navi Mumbai and Pune for business travelers, families, and tourists. The route is popular for daily travel, corporate commuting, and airport transfers. Our fleet includes comfortable sedans, SUVs, and spacious MPV vehicles suitable for highway journeys. Professional drivers ensure safe driving and punctual pickups from homes, offices, hotels, and railway stations across Navi Mumbai. Vehicles provide spacious seating, strong AC cooling, and luggage space for relaxed travel. The service is ideal for one-way trips, round-trip travel, and daily commuting. Travelers enjoy smooth and reliable transportation between Navi Mumbai and Pune."
},
{
name: "Navi Mumbai to Pune Taxi",
description: "Navi Mumbai to Pune taxi service offers dependable road transportation for travelers moving between the two major cities. The taxi provides comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickups and safe driving throughout the journey. Vehicles are well maintained with clean interiors and air-conditioned comfort. The service is ideal for corporate travel, weekend trips, and family journeys. Travelers can conveniently reach Pune from Navi Mumbai without relying on public transport. Passengers enjoy relaxed and reliable intercity taxi travel."
},
{
name: "Navi Mumbai to Pune Daily Cab Service",
description: "Navi Mumbai to Pune daily cab service provides regular transportation for passengers commuting between the two cities. This service is widely used by corporate employees, students, and frequent travelers. Vehicles provide comfortable seating and smooth ride quality for daily travel. Professional drivers ensure timely pickups and safe highway driving. The service operates with flexible pickup locations across Navi Mumbai. Travelers enjoy convenient daily commuting without transportation stress. It provides reliable and consistent cab service for frequent travel."
},
{
name: "Navi Mumbai Pune Cab Service",
description: "Navi Mumbai Pune cab service offers reliable intercity transportation for travelers planning trips between Navi Mumbai and Pune. The vehicles provide spacious seating and smooth driving performance for comfortable journeys. Professional drivers ensure punctual pickup services and safe driving along the expressway. The service is suitable for business meetings, tourism, and family visits. Vehicles provide strong AC cooling and comfortable interiors for passengers. Travelers benefit from flexible travel schedules and dependable service. It ensures smooth and convenient travel between the two cities."
},
{
name: "Cab from Navi Mumbai to Pune",
description: "Cab from Navi Mumbai to Pune provides convenient intercity transportation for travelers requiring comfortable road travel. Vehicles provide smooth ride quality and spacious seating suitable for highway journeys. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai locations. The service is ideal for families, corporate travelers, and tourists. Passengers enjoy reliable transportation without delays. Vehicles provide air-conditioned comfort and luggage space for travelers. It ensures a relaxed and comfortable journey."
},
{
name: "Taxi from Navi Mumbai to Pune",
description: "Taxi from Navi Mumbai to Pune provides comfortable and dependable road transportation between the two cities. The taxi offers smooth ride quality and reliable highway performance for long journeys. Professional drivers ensure punctual pickups and safe driving throughout the route. Vehicles provide comfortable seating and efficient air conditioning. Travelers can easily reach Pune for business meetings, tourism, or family visits. The service supports flexible travel schedules and convenient pickups. Passengers enjoy stress-free taxi travel."
},
{
name: "Navi Mumbai to Pune Cab Booking",
description: "Navi Mumbai to Pune cab booking allows travelers to easily reserve vehicles for intercity journeys. Customers can choose sedans, SUVs, or MPV vehicles depending on group size and travel preferences. Online and phone booking options provide quick confirmation for trips. Professional drivers ensure safe travel and punctual pickups across Navi Mumbai. Vehicles provide comfortable interiors and reliable highway performance. Travelers enjoy convenient booking with flexible travel schedules. The service ensures dependable transportation planning."
},
{
name: "Navi Mumbai to Pune Taxi Booking Online",
description: "Navi Mumbai to Pune taxi booking online provides quick digital reservations for travelers planning trips to Pune. Customers can easily schedule taxis online and receive instant confirmation. Vehicles provide comfortable seating and smooth highway performance for long-distance travel. Professional drivers ensure punctual pickups and safe driving throughout the journey. The service is ideal for corporate travelers, tourists, and families. Online booking simplifies travel planning and saves time. Travelers enjoy hassle-free transportation."
},
{
name: "Navi Mumbai to Pune Cab Price",
description: "Navi Mumbai to Pune cab price options provide transparent fare estimates for travelers planning intercity trips. Pricing varies depending on vehicle type, travel duration, and service category. Customers can choose economical sedans or spacious SUVs based on their travel needs. The service offers competitive fares for highway travel between the two cities. Travelers receive clear pricing details before booking their trip. Vehicles ensure comfortable and reliable transportation. The service offers affordable and flexible cab travel."
},
{
name: "Navi Mumbai to Pune Taxi Fare",
description: "Navi Mumbai to Pune taxi fare services offer flexible pricing options depending on vehicle type and travel schedule. Travelers can select comfortable vehicles suited for individual or group travel. Professional drivers ensure safe driving and smooth travel along the expressway route. Vehicles provide comfortable seating and air-conditioned interiors for passengers. Families and business travelers enjoy reliable transportation. Transparent fare structure helps travelers plan their trips easily. The service provides convenient intercity taxi travel."
},
{
name: "Navi Mumbai to Pune One Way Cab",
description: "Navi Mumbai to Pune one way cab service provides economical intercity travel without return charges. This service is ideal for passengers who need direct drop service to Pune. Vehicles provide comfortable seating and reliable highway performance. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai locations. Travelers enjoy flexible travel options and convenient booking. The cab offers air-conditioned interiors and smooth ride quality. Passengers benefit from affordable one-way travel."
},
{
name: "Navi Mumbai to Pune Round Trip Taxi",
description: "Navi Mumbai to Pune round trip taxi service provides convenient two-way transportation for travelers planning return journeys. The vehicle remains available for the entire travel schedule allowing flexible meetings or sightseeing in Pune. Comfortable seating and powerful AC ensure relaxed travel during long journeys. Professional drivers ensure safe driving and reliable service. Ideal for business travel and family visits. Passengers enjoy convenient return travel planning. The service offers dependable round-trip transportation."
}
],

tableData: [
["Navi Mumbai to Pune Cab","Navi Mumbai to Pune Taxi"],
["Navi Mumbai to Pune Daily Cab Service","Navi Mumbai Pune Cab Service"],
["Cab from Navi Mumbai to Pune","Taxi from Navi Mumbai to Pune"],
["Navi Mumbai to Pune Cab Booking","Navi Mumbai to Pune Taxi Booking Online"],
["Navi Mumbai to Pune Cab Price","Navi Mumbai to Pune Taxi Fare"],
["Navi Mumbai to Pune One Way Cab","Navi Mumbai to Pune Round Trip Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in daily travel between Navi Mumbai and Pune. They are familiar with the Mumbai–Pune Expressway and alternate routes ensuring a smooth, safe, and timely journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai to Pune daily cab services. Customers receive clear information about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai to Pune daily cab service operates 24 hours a day. Whether you need early morning travel, office commute, or late-night return trips, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to ensure passengers enjoy a comfortable and stress-free travel experience."
  },
  {
    WhyChooseheading: "Flexible Daily Travel Options",
    WhyChoosedescription: "We offer flexible daily travel packages including one-way trips, round trips, and regular commuting services between Navi Mumbai and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential societies anywhere in Navi Mumbai for a smooth start to your Pune journey."
  },
  {
    WhyChooseheading: "Reliable Daily Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai to Pune daily cab services thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide daily cab service from Navi Mumbai to Pune?", answer: "Yes, Omshree Cabs provides reliable daily cab services between Navi Mumbai and Pune for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai to Pune?", answer: "The distance from Navi Mumbai to Pune is approximately 120 km via the Mumbai–Pune Expressway." },
  { question: "How long does the journey take?", answer: "The journey usually takes around 2.5 to 3 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Navi Mumbai to Pune?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai and Pune." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Pune daily cab service operates 24/7." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and weekends." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "We regularly travel from Navi Mumbai to Pune with Omshree Cabs. The drivers are punctual and the journey is always smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Mehta",
    feedback:
      "Excellent daily cab service between Navi Mumbai and Pune. Clean vehicle, professional driver, and reliable service.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers reliable daily cab services from Navi Mumbai to Pune. Enjoy comfortable, safe, and punctual travel with options for one-way or round-trip taxi rides.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai to Pune Daily Cab Service",
    "Navi Mumbai to Pune Cab",
    "Navi Mumbai to Pune Taxi",
    "Navi Mumbai Pune Cab Service",
    "One Way Cab Navi Mumbai to Pune",
    "Round Trip Taxi Navi Mumbai to Pune"
  ]
};





  return (
    <div>
      

<Helmet>
  <title>Navi Mumbai to Pune Daily Cab Service | Omshree Cab</title>
  <meta
    name="description"
    content="Book daily cab service from Navi Mumbai to Pune with Omshree Cab. Safe, comfortable, and punctual taxi rides for one-way or round-trip travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitopunedailycab;